import { observable, action } from 'mobx'
import Api from '@api/certification'
import { getMerchantInfo, HLJ_STATISTIC } from '@util'

export default class {
  @observable certificationList = []
  @observable isComplete = false

  @action
  init = async () => {
    const merchantId = getMerchantInfo().id
    const perPage = 20
    const {
      data: { list },
      success
    } = await Api.getCertificationList({
      merchantId,
      perPage
    })

    if (success) {
      this.certificationList = list
      this.isComplete = true
    }
  }

  @action
  addCertification = () => {
    this.certificationList = [
      { type: 'editor', isNew: true, id: new Date().getTime() },
      ...this.certificationList
    ]
  }

  @action
  nevigateToMerchantSchool = () => {
    HLJ_STATISTIC({
      element_tag: 'certificationBusinessSchool'
    })
    window.open(
      'https://m.hunliji.com/p/wedding/Public/wap/m/business-school-detail/index.html?id=186'
    )
  }

  @action
  deleteFirst = () => {
    this.certificationList.splice(0, 1)
  }
}
